export default "__VITE_ASSET__C73IfvjU__"